module.exports = __webpack_public_path__ + "img/8-0-0.956d08fd.png";